'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');let

GroupNotificationSettingsDirective=class GroupNotificationSettingsDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'group'];

}

get templateUrl(){
return'/templates/features/notificationSettings/components/groupNotificationSettingsDirective/groupNotificationSettingsTemplate';
}

get controller(){
return GroupNotificationSettingsController;
}};let


GroupNotificationSettingsController=class GroupNotificationSettingsController extends BaseController{
static get $inject(){return['$scope','uncaughtErrorHandler']}

constructor($scope,uncaughtErrorHandler){
super(uncaughtErrorHandler);

this._selectedNotificationType=this.group.notificationType;
this._isOpened=!1;

$scope.$watch('controller.group.notificationType',newNotificationType=>{
if(this._selectedNotificationType===newNotificationType){
return;
}

this._selectedNotificationType=newNotificationType;
});
}

get selectedNotificationType(){
return this._selectedNotificationType;
}

set selectedNotificationType(notificationType){
if(!_.exists(NotificationType[notificationType])){
return;
}

this._selectedNotificationType=notificationType;

if(this.group.notificationType===notificationType){
return;
}

this.group.notificationTypeChangedCommand.execute(notificationType);
}

get isOpened(){
return this._isOpened;
}

toggleAccordian(){
this._isOpened=!this._isOpened;
}};


module.exports=GroupNotificationSettingsDirective;
module.exports.controller=GroupNotificationSettingsController;
//# sourceMappingURL=groupNotificationSettingsDirective.js.map
